import React, { useEffect, useState } from "react"
import Modal from "../../Modal/Modal";
import Input from "../../input/input";
import style from "./variantModalRenderers.module.scss"
import CheckBox from "../../SelectionControls/Checkbox/Checkbox";
import Button from "../../Button/button";
import toPersianNumber from "../../../helpers/actions/toPersianNumber";
import toEnglishNumber from "../../../helpers/actions/toEnglishNumber";
import Toast from "../../Toast/Toast"
import Tooltip from "../../tooltip/tooltip";
import RadioButton from "../../SelectionControls/RadioButton/RadioButton";

const productCode = ["کد تنوع  سوم", "کد تنوع  چهارم", "کد تنوع  پنجم", "کد تنوع  ششم", "کد تنوع  هفتم"];
const editProductCode = ["کد تنوع اول", "کد تنوع دوم", "کد تنوع  سوم", "کد تنوع  چهارم", "کد تنوع  پنجم", "کد تنوع  ششم", "کد تنوع  هفتم"];

const groupDefaultValues = {
    open: false,
    err: "",
    value: [{ name: "کد تنوع دوم", value: "", tag: "0" }],
    id: "",
    channelId: "",
    success: false,
    lastStock: false,
    stock: ''
}
const editGroupDefaultValues = {
    open: false,
    err: "",
    id: "",
    channelId: "",
    success: false,
    selectedVariants: [],
    value: [],
    stock: ''
}
const VariantModalRenderer = (props) => {
    const [groupModal, setGroupModal] = useState({
        open: false,
        value: [{ name: "کد تنوع دوم", value: "", tag: "0" }],
        id: "",
        channelId: "",
        success: false,
        lastStock: false,
        stock: ''
    });
    const [editGroupModal, setEditGroupModal] = useState({
        open: false,
        err: "",
        id: "",
        channelId: "",
        success: false,
        selectedVariants: [],
        value: [],
        stock: ''
    });
    const [deleteGroupModal, setDeleteGroupModal] = useState({
        open: false,
        err: "",
        id: "",
        channelId: "",
        success: false,
        selectedVariants: [],
        value: [],
        stock: ''
    });
    const [errors, setErrors] = useState({})
    const [toast, setToast] = useState('')
    const [channelsModal, setchannelsModal] = useState({ show: false, selected: '' })
    //life cycles*****************************************************
    useEffect(() => {
        if (props.data && props.data.mergedVariants) {
            let editGp = editGroupModal;
            props.data.mergedVariants.forEach((item, index) => {
                let obj = {
                    value: item.DKPC,
                    tag: (index).toString(),
                    name: editProductCode[index],
                    isNew: false
                }
                editGp.value.push(obj)
            })
            console.log(editGp.value);
            if (props.deleteVariantId) {

            }
            setEditGroupModal({ ...editGp })
        }
    }, [props.data, props.deleteVariantId])
    //server calls****************************************************
    const groupProducts = () => {
        if (!groupModal.responsibilty) {
            setToast('.گزینه پذیرش مسئولیت و عواقب گروه‌بندی را علامت بزنید')
        } else {
            setToast('')
            let errs = errors;
            groupModal.value.forEach(item => {
                if (!item.value) {
                    errs[item.tag] = 'کد تنوع را وارد کنید.';
                    setErrors({ ...errs });
                } else {
                    errs[item.tag] = '';
                    setErrors({ ...errs });
                }
            })
            {
                if (groupModal.stock < 0) {
                    groupModal.stock.length < 1 ? errs['stock'] = 'موجودی را وارد کنید.' : errs['stock'] = 'مقدار وارد شده غیرمجاز است.';
                    setErrors({ ...errs });
                } else {
                    delete errs['stock'];
                    setErrors({ ...errs });
                }
            }
            if (!Object.keys(errors)) {
                errs = {}
                setErrors(errs)
                //server call
            }
        }
    }
    const deleteGroup = () => {
        let temp = [];
        editGroupModal.value.forEach(i => temp.push(i.value))
        let params = {
            ids: temp
        }

        //server call
    }
    const editGroup = () => {

        setToast('')
        let errs = errors;
        editGroupModal.value.forEach(item => {
            if (!item.value) {
                errs[item.tag] = 'کد تنوع را وارد کنید.';
                setErrors({ ...errs });
            } else {
                errs[item.tag] = '';
                setErrors({ ...errs });
            }
        })
        {

            editGroupModal.stock.length < 1 ? errs['stock'] = 'موجودی را وارد کنید.' : delete errs['stock'];
            setErrors({ ...errs });

        }
        if (!Object.keys(errors)) {
            errs = {}
            setErrors(errs)
            //server call
        }
    }
    //functions*******************************************************
    const addInput = (modalData, setModalData, labelArray) => {
        console.log("hello");
        let temp = modalData;
        let obj = {
            value: "",
            tag: (modalData.value.length).toString(),
            name: labelArray[modalData.value.length],
            isNew: true
        }
        if (temp.value.length < 6) {
            temp.value.push(obj);
            setModalData({ ...temp })
            // console.log(groupModal, "obj");
        }

    }
    const deleteInput = (tag, modalData, setModalData) => {
        let temp = modalData;
        let index = temp.value.findIndex(e => e.tag === tag);
        let errs = errors
        if (index > 0) {
            temp.value.splice(index, 1);
            delete errs[tag]
            setErrors({ ...errs })
        } else {
            temp.value[index].value = ""

        }
        temp.value.forEach((e, index) => {
            if (index > 0) {

                e.name = productCode[index - 1];
            }

        })
        setModalData({ ...temp });

    }

    //handlers********************************************************
    const closeModal = () => {
        let gp = groupModal;
        gp = { ...groupDefaultValues }
        setGroupModal({ ...gp });
        setEditGroupModal({ ...editGroupDefaultValues })
        setchannelsModal({ show: false, selected: '' })
        props.closeParent(props.tag);
    }

    const onchangeHandler = (tag, value, secondTag) => {
        if (secondTag === "group") {
            let gp = groupModal
            if (tag === 'stock') {
                gp[tag] = toEnglishNumber(value.target.value);
                setGroupModal({ ...gp })
            } else {
                let res = gp.value.findIndex(e => e.tag === tag);
                if (res >= 0) {
                    gp.value[res].value = toEnglishNumber(value.target.value);
                    setGroupModal({ ...gp })
                }
            }
        } else if (secondTag === "editGroup") {
            let gp = editGroupModal;
            if (tag === 'stock') {
                gp[tag] = toEnglishNumber(value.target.value);
                setEditGroupModal({ ...gp })
            } else {
                let res = gp.value.findIndex(e => e.tag === tag);
                console.log(res);
                if (res >= 0) {
                    gp.value[res].value = toEnglishNumber(value.target.value);
                    console.log(gp.value);
                    setEditGroupModal({ ...gp })
                }
            }
        }

    }
    const handleCheckBox = (e, value, tag, secondTag) => {
        if (tag === "group") {
            // console.log(e, tag, secondTag);
            let gp = groupModal;
            gp[secondTag] = !gp[secondTag]
            setGroupModal({ ...gp })
        } else if (tag === "editGroup") {
            if (secondTag !== 'lastStock') {
                let gp = editGroupModal;
                let index = gp.selectedVariants.indexOf(secondTag)
                index < 0 ?
                    gp.selectedVariants.push(secondTag)
                    :
                    gp.selectedVariants.splice(index, 1)
                setEditGroupModal({ ...gp })
            }
        }

    }
    const radioButtonHandler = (e, value, tag, secoundTag) => {
        let modal = channelsModal;
        modal.selected = tag
        setchannelsModal({ ...modal })
    }
    const selectChannelConfirm = () => {
        if (channelsModal.selected) {
            props.confirmFunction(channelsModal.selected)
            setToast('')
            closeModal()
        } else {
            setToast('پنل مورد نظر خود را انتخاب کنید.')
        }
    }
    //rennderers******************************************************
    const modalRenderer = (tag) => {
        switch (tag) {
            case "channels":
                return (

                    <div className={style.modalWrapper}>
                        <p className={style.channelModalText}>.پنل مورد نظرتان را جهت به‌روز رسانی انتخاب کنید</p>
                        {props.data.channels.map((item, index) => {
                            return <div className={style.channelRadioButton} key={index}>
                                <RadioButton
                                    value={item._id === channelsModal.selected ? true : false}
                                    disabled={false}
                                    tag={item._id}
                                    label={item.name}
                                    onclick={radioButtonHandler}
                                /></div>
                        })}
                        <div className={style.buttonPack}>
                            <div className={style.button}>
                                <Button
                                    disabled={false}
                                    tag="cancelUpdate"
                                    type="outline"
                                    label="انصراف"
                                    onclick={closeModal}
                                />
                            </div>
                            <div className={style.button}>
                                <Button
                                    disabled={false}
                                    tag="updateDG" channelss
                                    type="solid"
                                    label="به‌روز رسانی"
                                    onclick={selectChannelConfirm}
                                />
                            </div>
                        </div>
                    </div>

                )

            case "group": {
                // temp = variantList.find(product => product._id === groupModal.id);
                if (groupModal.success) {
                    return <div className={style.nameEditSuccess}>
                        <p className={style.successIcon}>f</p>
                        <p>.گروه‌بندی کد کالاهای مورد نظر با موفقیت انجام شد</p>
                        <Button
                            tag="confirm"
                            type="solid"
                            label="تایید"
                            onclick={() => {
                                closeModal();
                                props.refresh();
                                setToast('')
                            }}
                        />
                    </div>
                } else {
                    return (
                        <div className={style.container}>
                            <div className={style.group}>
                                <p>می‌توانید در صورت وجود یک کالا با دو نام متفاوت، آن را گروه‌بندی کرده و موجودی کالای
                                    خود را بین آن‌ها تقسیم کنید.</p>
                                <div className={style.dkc}>
                                    <p>{props.data && "DKPC - " + toPersianNumber(props.data.DKPC)}</p>
                                    <label>:کد تنوع</label>
                                </div>
                                {groupModal.value.map((e, index) => {
                                    return (
                                        <div className={style.inputwrapper} key={index}>
                                            <div className={style.input}>
                                                <Input
                                                    label={e.name}
                                                    placeholder={e.name}
                                                    tag={e.tag}
                                                    secondTag="group"
                                                    value={e.value}
                                                    error={errors[e.tag]}
                                                    onchange={onchangeHandler}
                                                    onblur={() => {
                                                    }}
                                                />
                                            </div>
                                            <div className={style.cancel} onClick={() => {
                                                deleteInput(e.tag, groupModal, setGroupModal)
                                            }}>e
                                            </div>
                                        </div>
                                    )
                                })}
                                <div className={style.addButton} onClick={() => {
                                    addInput(groupModal, setGroupModal, productCode)
                                }}>
                                    <button>i</button>
                                    <div className={style.buttonText}>{productCode[groupModal.value.length - 1]}</div>
                                </div>
                                <div className={style.inputwrapper}>
                                    <div className={style.input}>
                                        <Input
                                            label='موجودی'
                                            placeholder='موجودی'
                                            tag="stock"
                                            secondTag={"group"}
                                            value={groupModal.stock}
                                            tooltip={'موجودی کل قابل تقسیم بین تنوع‌های گروه شده'}
                                            error={errors["stock"]}
                                            onchange={onchangeHandler}
                                            onblur={() => {
                                            }}
                                        />
                                    </div>
                                </div>
                                <div className={style.checkBoxSection}>
                                    {/* {console.log(groupModal['lastStock'])} */}
                                    <div className={style.row}>
                                        <CheckBox
                                            label=".آخرین موجودی باقیمانده، تقسیم شود"
                                            value={groupModal['lastStock']}
                                            indeterminate={false}
                                            disabled={false}
                                            tag='group'
                                            secondTag='lastStock'
                                            onclick={handleCheckBox}
                                        />
                                        <Tooltip
                                            text='با تیک زدن این گزینه، می‌توانید با مسئولیت خود، آخرین موجودی باقیمانده را هم تقسیم کنید.'
                                            direction='Bottom' />
                                    </div>
                                    <div className={style.row}>
                                        <CheckBox
                                            label=".مسئولیت و عواقب گروه‌بندی را خوانده و می‌پذیرم"
                                            value={groupModal['responsibilty']}
                                            indeterminate={false}
                                            disabled={false}
                                            tag='group'
                                            secondTag='responsibilty'
                                            onclick={handleCheckBox}
                                        />
                                        <Tooltip
                                            text='ربات با توجه به بسته انتخابی شما (برنزی)، هر 60 دقیقه تنوع‌ها را بررسی و موجودی آن‌ها را به‌روز رسانی می‌کند
                                        .به همین دلیل آخرین موجودی باقیمانده تقسیم نخواهد نشد و فقط به یکی از تنوع‌ها اختصاص می‌یابد'
                                            direction='Bottom' />
                                    </div>
                                </div>
                                <div className={style.warning}>
                                    <span>h</span>
                                    <p>توجه داشته باشید که کالاهای موجود در پروموشن به صورت موقت از گروه‌بندی حذف
                                        می‌شوند. </p>
                                </div>


                            </div>
                            {ButtonPackRenderer("group", "groupCancel", "گروه‌بندی", groupProducts, groupModal, setGroupModal)}
                        </div>
                    )
                }
            }
            case "editGroup": {
                if (groupModal.success) {
                    return <div className={style.nameEditSuccess}>
                        <p className={style.successIcon}>f</p>
                        <p>.ویرایش گروه‌بندی با موفقیت انجام شد</p>
                        <Button
                            tag="confirm"
                            type="solid"
                            label="تایید"
                            onclick={() => {
                                closeModal();
                                props.refresh();
                                setToast('')
                            }}
                        />
                    </div>
                } else {
                    return editRenderer("editGroup")
                }
            }
            case "deleteFromGroup": {
                if (groupModal.success) {
                    return <div className={style.nameEditSuccess}>
                        <p className={style.warningIcon}>h</p>
                        <p>.ویرایش گروه‌بندی با موفقیت انجام شد</p>
                        <Button
                            tag="confirm"
                            type="solid"
                            label="تایید"
                            onclick={() => {
                                closeModal();
                                props.refresh();
                                setToast('')
                            }}
                        />
                    </div>
                } else {
                    return editRenderer("deleteFromGroup")
                }
            }
        }

    }
    const editRenderer = (type) => {
        return (
            <div className={style.container}>
                <div className={style.group}>
                    <p>می‌توانید با ویرایش موارد زیر، تنوع‌های مورد نظر خود را از گروه‌بندی حذف، اضافه و یا موجودی آن‌ها
                        را به‌روز رسانی کنید.</p>
                    <div className={style.variantGroupdLabel}>
                        :تنوع‌های گروه‌‌بندی
                    </div>
                    {
                        type !== "editGroup" &&
                        <div className={style.row}>
                            <CheckBox
                                label={"DKPC - " + toPersianNumber(props.data.DKPC)}
                                value={editGroupModal.selectedVariants.includes(props.data.DKPC) ? false : true}
                                indeterminate={false}
                                disabled={false}
                                tag='editGroup'
                                secondTag={props.data.DKPC}
                                onclick={handleCheckBox}
                                lineThrough={editGroupModal.selectedVariants.includes(props.data.DKPC)}
                            />
                        </div>
                    }
                    {
                        props.data.mergedVariants.map((item, index) => {
                            return <div className={style.row} key={index}>
                                <CheckBox
                                    label={"DKPC - " + toPersianNumber(item.DKPC)}
                                    value={editGroupModal.selectedVariants.includes(item.DKPC) ? false : true}
                                    indeterminate={false}
                                    disabled={false}
                                    tag='editGroup'
                                    secondTag={item.DKPC}
                                    onclick={handleCheckBox}
                                    lineThrough={editGroupModal.selectedVariants.includes(item.DKPC)}
                                />
                                {editGroupModal.selectedVariants.includes(item.DKPC) ?
                                    <div className={style.info}>(حذف پس از تایید)</div>
                                    : null}
                            </div>
                        })
                    }
                    {type === "editGroup" &&
                        <React.Fragment>
                            {editGroupModal.value.map((e, index) => {
                                return (
                                    e.isNew && <div className={style.inputwrapper} key={index}>
                                        <div className={style.input}>
                                            <Input
                                                label={e.name}
                                                placeholder={e.name}
                                                tag={e.tag}
                                                secondTag="editGroup"
                                                value={e.value}
                                                error={errors[e.tag]}
                                                onchange={onchangeHandler}
                                                onblur={() => {
                                                }}
                                            />
                                        </div>
                                        <div className={style.cancel} onClick={() => {
                                            deleteInput(e.tag, editGroupModal, setEditGroupModal)
                                        }}>e
                                        </div>
                                    </div>
                                )
                            })}
                            <div className={style.addButton} onClick={() => {
                                addInput(editGroupModal, setEditGroupModal, editProductCode)
                            }}>
                                <button>i</button>
                                <div className={style.buttonText}>{editProductCode[editGroupModal.value.length]}</div>
                            </div>
                        </React.Fragment>
                    }
                    <div className={style.warningOrange}>
                        <span>h</span>
                        <p>موجودی کد تنوع‌های حذف شده را از پنل دیجی‌کالا خود تغییر دهید.</p>
                    </div>
                    <div className={style.splitter}></div>
                    <div className={style.inputwrapper}>
                        <div className={style.input}>
                            <Input
                                label='موجودی تنوع‌های گروه‌بندی'
                                placeholder='موجودی'
                                tag="stock"
                                secondTag={"editGroup"}
                                value={editGroupModal.stock}
                                tooltip={'موجودی کل قابل تقسیم بین تنوع‌های گروه شده'}
                                error={errors["stock"]}
                                onchange={onchangeHandler}
                                onblur={() => {
                                }}
                            />
                        </div>
                    </div>
                    <div className={style.checkBoxSection}>
                        <div className={style.row}>
                            <CheckBox
                                label=".آخرین موجودی باقیمانده، تقسیم شود"
                                value={groupModal['lastStock']}
                                indeterminate={false}
                                disabled={false}
                                tag='group'
                                secondTag='lastStock'
                                onclick={handleCheckBox}
                            />
                            <Tooltip
                                // text='با تیک زدن این گزینه، می‌توانید با مسئولیت خود، آخرین موجودی باقیمانده را هم تقسیم کنید.'
                                text=' با تیک زدن این گزینه، می‌توانید با مسئولیت خود، آخرین موجودی باقیمانده را هم تقسیم کنی با تیک زدن این گزینه، می‌توانید با مسئولیت خود، آخرین موجودی باقیمانده را هم تقسیم کنید.'
                                direction='Bottom' />
                        </div>
                    </div>
                    <div className={style.warning}>
                        <span>h</span>
                        <p>توجه داشته باشید که کالاهای موجود در پروموشن به صورت موقت از گروه‌بندی حذف می‌شوند. </p>
                    </div>


                </div>
                {threeButtonPackRenderer("editGroup", "deleteEditGroup", "editGroupCancel", "ثبت تغییرات", "حذف کامل گروه‌بندی", editGroup, deleteGroup, editGroupModal, setEditGroupModal)}
            </div>
        )
    }
    const ButtonPackRenderer = (maintag, canceltag, mainlabel, mainaction, get, set) => {
        return (
            <div className={style.buttonPack}>
                <div className={style.button}>
                    <Button
                        disabled={false}
                        tag={canceltag}
                        type="outline"
                        label="انصراف"
                        onclick={() => {
                            closeModal();
                            setToast('')
                        }} />
                </div>
                <div className={style.button}>
                    <Button
                        disabled={false}
                        tag={maintag}
                        type="solid"
                        label={mainlabel}
                        onclick={() => mainaction()}
                    />
                </div>
            </div>
        )
    }
    const threeButtonPackRenderer = (maintag, secondTag, canceltag, mainlabel, secondLabel, mainaction, secondAction, get, set) => {
        return (
            <div className={style.buttonPack}>
                <div className={style.threePackButton}>
                    <Button
                        disabled={false}
                        tag={canceltag}
                        type="outline"
                        label="انصراف"
                        onclick={() => {
                            closeModal();
                            setToast('')
                        }} />
                </div>
                <div className={style.threePackButton}>
                    <Button
                        disabled={false}
                        tag={secondTag}
                        type="outline"
                        label={secondLabel}
                        onclick={() => {
                            closeModal();
                            secondAction();
                            setToast('')
                        }} />
                </div>
                <div className={style.threePackButton}>
                    <Button
                        disabled={false}
                        tag={maintag}
                        type="solid"
                        label={mainlabel}
                        onclick={() => mainaction()}
                    />
                </div>
            </div>
        )
    }
    return (
        <div className={style.wrapper}>
            <Toast
                tag='Toast_1'
                text={toast}
                value={toast}
                parentClose={() => setToast('')}
            />
            <Modal
                tag={props.tag}
                value={props.value}
                title={props.title}
                parentClose={() => closeModal()}
            >
                {modalRenderer(props.tag)}

            </Modal>
        </div>
    )
}

export default VariantModalRenderer;

